import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Hero } from './components/Hero';
import { Quiz } from './components/Quiz';
import { Loading } from './components/Loading';
import { Result } from './components/Result';
import { Sales } from './components/Sales';
import { useScreenInit } from './useScreenInit.js';
type Screen = 'hero' | 'quiz' | 'loading' | 'result' | 'sales';
export function App() {
  const screenInit = useScreenInit();
  const [currentScreen, setCurrentScreen] = useState<Screen>(screenInit?.step as Screen || 'hero');
  const [answers, setAnswers] = useState<Record<number, number>>({});
  const handleStart = () => {
    setCurrentScreen('quiz');
  };
  const handleQuizComplete = (quizAnswers: Record<number, number>) => {
    setAnswers(quizAnswers);
    setCurrentScreen('loading');
  };
  const handleLoadingComplete = () => {
    setCurrentScreen('result');
  };
  const handleResultContinue = () => {
    setCurrentScreen('sales');
  };
  const handleBackToHero = () => {
    setCurrentScreen('hero');
  };
  return <div className="w-full min-h-screen bg-black overflow-x-hidden" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {currentScreen === 'hero' && <Hero key="hero" onStart={handleStart} data-id="element-2" />}
        {currentScreen === 'quiz' && <Quiz key="quiz" onComplete={handleQuizComplete} onBack={handleBackToHero} data-id="element-3" />}
        {currentScreen === 'loading' && <Loading key="loading" onComplete={handleLoadingComplete} data-id="element-4" />}
        {currentScreen === 'result' && <Result key="result" onContinue={handleResultContinue} data-id="element-5" />}
        {currentScreen === 'sales' && <Sales key="sales" data-id="element-6" />}
      </AnimatePresence>
    </div>;
}